import * as yup from "yup";

const emailREGX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

const FormValidationSAcc = yup.object().shape({
  firstName: yup.string().required("Selection is required"),
  lastName: yup
    .string()
    .max(60, "Name cannot exceed 60 characters")
    .required("Name is required"),
  email: yup
    .string()
    .max(50, "Email cannot exceed 50 characters")
    .required("Email is required")
    .matches(emailREGX, "Invalid Email"),
  relation: yup.string().required("Relationship is Required"),
});

export default FormValidationSAcc;
